import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import styles from './RequestedHeaderTable.module.scss';
import {
    bookedAtSorter,
    checkInSorter,
    checkOutSorter,
    clientSorter,
    nightsSorter,
    petSorter,
    serviceSorter,
    staffSorter,
    totalSorter
} from './sorting';
import { getServiceCategoryByTabId } from './tabs';
import { Sorter } from '@spike/appointments-list-model';

interface RequestedHeaderTableProps {
    selectedTabId: string;
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
}

export const RequestedHeaderTable: FunctionComponent<RequestedHeaderTableProps> = props => {
    const serviceCategory = getServiceCategoryByTabId(props.selectedTabId);

    return (
        <TableHeader>
            <HeaderTableColumn
                columnSorter={clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            {serviceCategory === 'grooming' && (
                <HeaderTableColumn
                    columnSorter={staffSorter}
                    selectedSorter={props.sorter}
                    onSort={props.onSort}
                >
                    Staff
                </HeaderTableColumn>
            )}
            {serviceCategory === 'boarding' ? (
                <>
                    <HeaderTableColumn
                        columnSorter={checkInSorter}
                        selectedSorter={props.sorter}
                        onSort={props.onSort}
                    >
                        Check In
                    </HeaderTableColumn>
                    <HeaderTableColumn
                        columnSorter={checkOutSorter}
                        selectedSorter={props.sorter}
                        onSort={props.onSort}
                    >
                        Check Out
                    </HeaderTableColumn>
                    <HeaderTableColumn
                        columnSorter={nightsSorter}
                        selectedSorter={props.sorter}
                        onSort={props.onSort}
                        className={styles.nights}
                    >
                        <FontAwesomeIcon icon={faMoon} />
                    </HeaderTableColumn>
                </>
            ) : (
                <HeaderTableColumn
                    columnSorter={bookedAtSorter}
                    selectedSorter={props.sorter}
                    onSort={props.onSort}
                >
                    Date & Time
                </HeaderTableColumn>
            )}
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default RequestedHeaderTable;
